import React from 'react';

export default function HomePanel({
  title,
  icon,
  rightSlot,
  className = '',
  bodyClassName = 'p-4',
  children,
}) {
  return (
    <section
      className={[
        'rounded-xl border border-gray-200/80 dark:border-gray-800/80',
        'bg-white/80 dark:bg-gray-900/70 backdrop-blur',
        'shadow-sm',
        'flex flex-col',
        className,
      ].join(' ')}
    >
      {(title || icon || rightSlot) && (
        <header className="flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-200/70 dark:border-gray-800/70">
          <div className="flex items-center gap-2 min-w-0">
            {icon && (
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200">
                {icon}
              </span>
            )}
            {title && (
              <h2 className="text-sm font-semibold tracking-wide text-gray-900 dark:text-white truncate">
                {title}
              </h2>
            )}
          </div>
          {rightSlot && <div className="flex-shrink-0">{rightSlot}</div>}
        </header>
      )}

      <div className={['flex-1 min-h-0', bodyClassName].join(' ')}>{children}</div>
    </section>
  );
}

